export class Entidad {
  centCodigo: string;
  centNombre = '';
  centRuc: string;
  centDirecc: string;
  centDirdep: string;
  centDirpro: string;
  centDirdis: string;
  centDirRef: string;
  cuniCodigo: string;
}

export class ResponseCaptcha {
  success: boolean;
  token: string;
}
